module.exports = new __parcel__URL__("volume-slider.f5ccdae0.png").toString();